import { QimaOptionalType } from '@qima/ngx-qima';
import { Token } from './token';
import { User } from './user';

export interface SessionData {
  user: User;
  token: Token;
  isAuthenticated?: QimaOptionalType<boolean>;
}

export class Session {
  public user: User;
  public token: Token;
  public isAuthenticated: boolean;

  constructor(data: SessionData) {
    this.user = data.user instanceof User ? data.user : new User(data.user);
    this.token = data.token instanceof Token ? data.token : new Token(data.token);
    this.isAuthenticated = data.isAuthenticated ?? true;
  }

  get isValid(): boolean {
    return this.token.validity && this.user.isActive;
  }

  get isExpired(): boolean {
    return this.token.isExpired;
  }

  toJSON() {
    return {
      user: this.user.toJSON(),
      token: this.token.toJSON(),
      isAuthenticated: this.isAuthenticated,
    };
  }
}
